export const NAVIGATION_HEIGHT = '--anwb_main_navigation_height';
